import durationCoverageBaseValidator from './durationCoverage';

export default durationCoverageBaseValidator;
